import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import BaseModal from '../../../../components/modals/BaseModal';
import { updateInventoryItem } from '../../../../repository/InventoryDAO';
import { useLoadingContext } from '../../../../context/loading/LoadingContext';
import { useUserContext } from '../../../../context/user_context/UserContext';
import { useToast } from '../../../../context/toast/ToastContext';
import { StringKeys } from '../../../../resources/strings/StringKeys';
import { useTranslation } from 'react-i18next';

const EditInventoryLinkModal = ({ show, onHide, item }) => {

    const [link, setLink] = useState("");
    const { setLoadingData } = useLoadingContext()
    const { firebaseUser } = useUserContext()
    const { showToast } = useToast()
    const{ t } = useTranslation()

    useEffect(() => {
        if(item) setLink(item.link)
    },[item, show])  

    const handleSubmit = async () => {
        setLoadingData(true);
        const newItem = {
            link: link
        }
        await updateInventoryItem(firebaseUser.organization, item.id, newItem, showToast);
        setLoadingData(false);
        resetForm();
        onHide();
    };

    const resetForm = () => {
        setLink("");
    };


    const actions = (
        <Button onClick={handleSubmit}>{t(StringKeys.SUBMIT)}</Button>
    );

    if(!item) return

    return (
        <BaseModal
            open={show}
            onClose={onHide}
            title={t(StringKeys.EDIT_PRODUCT_LINK)}
            actions={actions}
        >
            <TextField
                autoFocus
                margin="dense"
                id="link"
                label={t(StringKeys.PRODUCT_LINK)}
                type="text"
                fullWidth
                variant="outlined"
                value={link}
                onChange={(e) => setLink(e.target.value)}
            />     
        </BaseModal>
    );
};

export default EditInventoryLinkModal